import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.promise.finally.js";
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function e(t) {
  var e = {
    exports: {}
  };
  return t(e, e.exports), e.exports;
}
var r = e(function (e, r) {
    e.exports = function () {
      function e(t) {
        return "function" == typeof t;
      }
      var r = Array.isArray ? Array.isArray : function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        },
        i = 0,
        n = void 0,
        o = void 0,
        s = function s(t, e) {
          l[i] = t, l[i + 1] = e, 2 === (i += 2) && (o ? o(d) : w());
        },
        h = "undefined" != typeof window ? window : void 0,
        u = h || {},
        a = u.MutationObserver || u.WebKitMutationObserver,
        f = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
        c = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
      function p() {
        var t = setTimeout;
        return function () {
          return t(d, 1);
        };
      }
      var l = new Array(1e3);
      function d() {
        for (var t = 0; t < i; t += 2) {
          (0, l[t])(l[t + 1]), l[t] = void 0, l[t + 1] = void 0;
        }
        i = 0;
      }
      var m,
        v,
        y,
        g,
        w = void 0;
      function T(t, e) {
        var r = this,
          i = new this.constructor(S);
        void 0 === i[_] && O(i);
        var n = r._state;
        if (n) {
          var o = arguments[n - 1];
          s(function () {
            return R(n, i, o, r._result);
          });
        } else I(r, i, t, e);
        return i;
      }
      function b(t) {
        if (t && "object" == typeof t && t.constructor === this) return t;
        var e = new this(S);
        return B(e, t), e;
      }
      w = f ? function () {
        return process.nextTick(d);
      } : a ? (v = 0, y = new a(d), g = document.createTextNode(""), y.observe(g, {
        characterData: !0
      }), function () {
        g.data = v = ++v % 2;
      }) : c ? ((m = new MessageChannel()).port1.onmessage = d, function () {
        return m.port2.postMessage(0);
      }) : void 0 === h ? function () {
        try {
          var t = Function("return this")().require("vertx");
          return void 0 !== (n = t.runOnLoop || t.runOnContext) ? function () {
            n(d);
          } : p();
        } catch (t) {
          return p();
        }
      }() : p();
      var _ = Math.random().toString(36).substring(2);
      function S() {}
      var A = void 0;
      function D(t, r, i) {
        r.constructor === t.constructor && i === T && r.constructor.resolve === b ? function (t, e) {
          1 === e._state ? E(t, e._result) : 2 === e._state ? k(t, e._result) : I(e, void 0, function (e) {
            return B(t, e);
          }, function (e) {
            return k(t, e);
          });
        }(t, r) : void 0 === i ? E(t, r) : e(i) ? function (t, e, r) {
          s(function (t) {
            var i = !1,
              n = function (r, n, o, s) {
                try {
                  r.call(n, function (r) {
                    i || (i = !0, e !== r ? B(t, r) : E(t, r));
                  }, function (e) {
                    i || (i = !0, k(t, e));
                  });
                } catch (t) {
                  return t;
                }
              }(r, e);
            !i && n && (i = !0, k(t, n));
          }, t);
        }(t, r, i) : E(t, r);
      }
      function B(t, e) {
        if (t === e) k(t, new TypeError("You cannot resolve a promise with itself"));else if (n = typeof (i = e), null === i || "object" !== n && "function" !== n) E(t, e);else {
          var r = void 0;
          try {
            r = e.then;
          } catch (e) {
            return void k(t, e);
          }
          D(t, e, r);
        }
        var i, n;
      }
      function x(t) {
        t._onerror && t._onerror(t._result), M(t);
      }
      function E(t, e) {
        t._state === A && (t._result = e, t._state = 1, 0 !== t._subscribers.length && s(M, t));
      }
      function k(t, e) {
        t._state === A && (t._state = 2, t._result = e, s(x, t));
      }
      function I(t, e, r, i) {
        var n = t._subscribers,
          o = n.length;
        t._onerror = null, n[o] = e, n[o + 1] = r, n[o + 2] = i, 0 === o && t._state && s(M, t);
      }
      function M(t) {
        var e = t._subscribers,
          r = t._state;
        if (0 !== e.length) {
          for (var i = void 0, n = void 0, o = t._result, s = 0; s < e.length; s += 3) {
            n = e[s + r], (i = e[s]) ? R(r, i, n, o) : n(o);
          }
          t._subscribers.length = 0;
        }
      }
      function R(t, r, i, n) {
        var o = e(i),
          s = void 0,
          h = void 0,
          u = !0;
        if (o) {
          try {
            s = i(n);
          } catch (t) {
            u = !1, h = t;
          }
          if (r === s) return void k(r, new TypeError("A promises callback cannot return that same promise."));
        } else s = n;
        r._state !== A || (o && u ? B(r, s) : !1 === u ? k(r, h) : 1 === t ? E(r, s) : 2 === t && k(r, s));
      }
      var C = 0;
      function O(t) {
        t[_] = C++, t._state = void 0, t._result = void 0, t._subscribers = [];
      }
      var j = function () {
          function t(t, e) {
            this._instanceConstructor = t, this.promise = new t(S), this.promise[_] || O(this.promise), r(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? E(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && E(this.promise, this._result))) : k(this.promise, new Error("Array Methods must be provided an Array"));
          }
          return t.prototype._enumerate = function (t) {
            for (var e = 0; this._state === A && e < t.length; e++) {
              this._eachEntry(t[e], e);
            }
          }, t.prototype._eachEntry = function (t, e) {
            var r = this._instanceConstructor,
              i = r.resolve;
            if (i === b) {
              var n = void 0,
                o = void 0,
                s = !1;
              try {
                n = t.then;
              } catch (t) {
                s = !0, o = t;
              }
              if (n === T && t._state !== A) this._settledAt(t._state, e, t._result);else if ("function" != typeof n) this._remaining--, this._result[e] = t;else if (r === N) {
                var h = new r(S);
                s ? k(h, o) : D(h, t, n), this._willSettleAt(h, e);
              } else this._willSettleAt(new r(function (e) {
                return e(t);
              }), e);
            } else this._willSettleAt(i(t), e);
          }, t.prototype._settledAt = function (t, e, r) {
            var i = this.promise;
            i._state === A && (this._remaining--, 2 === t ? k(i, r) : this._result[e] = r), 0 === this._remaining && E(i, this._result);
          }, t.prototype._willSettleAt = function (t, e) {
            var r = this;
            I(t, void 0, function (t) {
              return r._settledAt(1, e, t);
            }, function (t) {
              return r._settledAt(2, e, t);
            });
          }, t;
        }(),
        N = function () {
          function t(e) {
            this[_] = C++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function () {
              throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            }(), this instanceof t ? function (t, e) {
              try {
                e(function (e) {
                  B(t, e);
                }, function (e) {
                  k(t, e);
                });
              } catch (e) {
                k(t, e);
              }
            }(this, e) : function () {
              throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }());
          }
          return t.prototype.catch = function (t) {
            return this.then(null, t);
          }, t.prototype.finally = function (t) {
            var r = this,
              i = r.constructor;
            return e(t) ? r.then(function (e) {
              return i.resolve(t()).then(function () {
                return e;
              });
            }, function (e) {
              return i.resolve(t()).then(function () {
                throw e;
              });
            }) : r.then(t, t);
          }, t;
        }();
      return N.prototype.then = T, N.all = function (t) {
        return new j(this, t).promise;
      }, N.race = function (t) {
        var e = this;
        return r(t) ? new e(function (r, i) {
          for (var n = t.length, o = 0; o < n; o++) {
            e.resolve(t[o]).then(r, i);
          }
        }) : new e(function (t, e) {
          return e(new TypeError("You must pass an array to race."));
        });
      }, N.resolve = b, N.reject = function (t) {
        var e = new this(S);
        return k(e, t), e;
      }, N._setScheduler = function (t) {
        o = t;
      }, N._setAsap = function (t) {
        s = t;
      }, N._asap = s, N.polyfill = function () {
        var e = void 0;
        if (void 0 !== t) e = t;else if ("undefined" != typeof self) e = self;else try {
          e = Function("return this")();
        } catch (t) {
          throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var r = e.Promise;
        if (r) {
          var i = null;
          try {
            i = Object.prototype.toString.call(r.resolve());
          } catch (t) {}
          if ("[object Promise]" === i && !r.cast) return;
        }
        e.Promise = N;
      }, N.Promise = N, N;
    }();
  }),
  i = {
    __proto__: null,
    default: {}
  },
  n = e(function (e, r) {
    var n;
    e.exports = n = n || function (e, r) {
      var n;
      if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== t && t.crypto && (n = t.crypto), !n) try {
        n = i;
      } catch (t) {}
      var o = function o() {
          if (n) {
            if ("function" == typeof n.getRandomValues) try {
              return n.getRandomValues(new Uint32Array(1))[0];
            } catch (t) {}
            if ("function" == typeof n.randomBytes) try {
              return n.randomBytes(4).readInt32LE();
            } catch (t) {}
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        },
        s = Object.create || function () {
          function t() {}
          return function (e) {
            var r;
            return t.prototype = e, r = new t(), t.prototype = null, r;
          };
        }(),
        h = {},
        u = h.lib = {},
        a = u.Base = {
          extend: function extend(t) {
            var e = s(this);
            return t && e.mixIn(t), e.hasOwnProperty("init") && this.init !== e.init || (e.init = function () {
              e.$super.init.apply(this, arguments);
            }), e.init.prototype = e, e.$super = this, e;
          },
          create: function create() {
            var t = this.extend();
            return t.init.apply(t, arguments), t;
          },
          init: function init() {},
          mixIn: function mixIn(t) {
            for (var e in t) {
              t.hasOwnProperty(e) && (this[e] = t[e]);
            }
            t.hasOwnProperty("toString") && (this.toString = t.toString);
          },
          clone: function clone() {
            return this.init.prototype.extend(this);
          }
        },
        f = u.WordArray = a.extend({
          init: function init(t, e) {
            t = this.words = t || [], this.sigBytes = null != e ? e : 4 * t.length;
          },
          toString: function toString(t) {
            return (t || p).stringify(this);
          },
          concat: function concat(t) {
            var e = this.words,
              r = t.words,
              i = this.sigBytes,
              n = t.sigBytes;
            if (this.clamp(), i % 4) for (var o = 0; o < n; o++) {
              e[i + o >>> 2] |= (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 24 - (i + o) % 4 * 8;
            } else for (var s = 0; s < n; s += 4) {
              e[i + s >>> 2] = r[s >>> 2];
            }
            return this.sigBytes += n, this;
          },
          clamp: function clamp() {
            var t = this.words,
              r = this.sigBytes;
            t[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, t.length = e.ceil(r / 4);
          },
          clone: function clone() {
            var t = a.clone.call(this);
            return t.words = this.words.slice(0), t;
          },
          random: function random(t) {
            for (var e = [], r = 0; r < t; r += 4) {
              e.push(o());
            }
            return new f.init(e, t);
          }
        }),
        c = h.enc = {},
        p = c.Hex = {
          stringify: function stringify(t) {
            for (var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++) {
              var o = e[n >>> 2] >>> 24 - n % 4 * 8 & 255;
              i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
            }
            return i.join("");
          },
          parse: function parse(t) {
            for (var e = t.length, r = [], i = 0; i < e; i += 2) {
              r[i >>> 3] |= parseInt(t.substr(i, 2), 16) << 24 - i % 8 * 4;
            }
            return new f.init(r, e / 2);
          }
        },
        l = c.Latin1 = {
          stringify: function stringify(t) {
            for (var e = t.words, r = t.sigBytes, i = [], n = 0; n < r; n++) {
              i.push(String.fromCharCode(e[n >>> 2] >>> 24 - n % 4 * 8 & 255));
            }
            return i.join("");
          },
          parse: function parse(t) {
            for (var e = t.length, r = [], i = 0; i < e; i++) {
              r[i >>> 2] |= (255 & t.charCodeAt(i)) << 24 - i % 4 * 8;
            }
            return new f.init(r, e);
          }
        },
        d = c.Utf8 = {
          stringify: function stringify(t) {
            try {
              return decodeURIComponent(escape(l.stringify(t)));
            } catch (t) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function parse(t) {
            return l.parse(unescape(encodeURIComponent(t)));
          }
        },
        m = u.BufferedBlockAlgorithm = a.extend({
          reset: function reset() {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          _append: function _append(t) {
            "string" == typeof t && (t = d.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
          },
          _process: function _process(t) {
            var r,
              i = this._data,
              n = i.words,
              o = i.sigBytes,
              s = this.blockSize,
              h = o / (4 * s),
              u = (h = t ? e.ceil(h) : e.max((0 | h) - this._minBufferSize, 0)) * s,
              a = e.min(4 * u, o);
            if (u) {
              for (var c = 0; c < u; c += s) {
                this._doProcessBlock(n, c);
              }
              r = n.splice(0, u), i.sigBytes -= a;
            }
            return new f.init(r, a);
          },
          clone: function clone() {
            var t = a.clone.call(this);
            return t._data = this._data.clone(), t;
          },
          _minBufferSize: 0
        });
      u.Hasher = m.extend({
        cfg: a.extend(),
        init: function init(t) {
          this.cfg = this.cfg.extend(t), this.reset();
        },
        reset: function reset() {
          m.reset.call(this), this._doReset();
        },
        update: function update(t) {
          return this._append(t), this._process(), this;
        },
        finalize: function finalize(t) {
          return t && this._append(t), this._doFinalize();
        },
        blockSize: 16,
        _createHelper: function _createHelper(t) {
          return function (e, r) {
            return new t.init(r).finalize(e);
          };
        },
        _createHmacHelper: function _createHmacHelper(t) {
          return function (e, r) {
            return new v.HMAC.init(t, r).finalize(e);
          };
        }
      });
      var v = h.algo = {};
      return h;
    }(Math);
  }),
  o = e(function (t, e) {
    var r;
    t.exports = (r = n, function (t) {
      var e = r,
        i = e.lib,
        n = i.WordArray,
        o = i.Hasher,
        s = e.algo,
        h = [],
        u = [];
      !function () {
        function e(e) {
          for (var r = t.sqrt(e), i = 2; i <= r; i++) {
            if (!(e % i)) return !1;
          }
          return !0;
        }
        function r(t) {
          return 4294967296 * (t - (0 | t)) | 0;
        }
        for (var i = 2, n = 0; n < 64;) {
          e(i) && (n < 8 && (h[n] = r(t.pow(i, .5))), u[n] = r(t.pow(i, 1 / 3)), n++), i++;
        }
      }();
      var a = [],
        f = s.SHA256 = o.extend({
          _doReset: function _doReset() {
            this._hash = new n.init(h.slice(0));
          },
          _doProcessBlock: function _doProcessBlock(t, e) {
            for (var r = this._hash.words, i = r[0], n = r[1], o = r[2], s = r[3], h = r[4], f = r[5], c = r[6], p = r[7], l = 0; l < 64; l++) {
              if (l < 16) a[l] = 0 | t[e + l];else {
                var d = a[l - 15],
                  m = a[l - 2];
                a[l] = ((d << 25 | d >>> 7) ^ (d << 14 | d >>> 18) ^ d >>> 3) + a[l - 7] + ((m << 15 | m >>> 17) ^ (m << 13 | m >>> 19) ^ m >>> 10) + a[l - 16];
              }
              var v = i & n ^ i & o ^ n & o,
                y = p + ((h << 26 | h >>> 6) ^ (h << 21 | h >>> 11) ^ (h << 7 | h >>> 25)) + (h & f ^ ~h & c) + u[l] + a[l];
              p = c, c = f, f = h, h = s + y | 0, s = o, o = n, n = i, i = y + (((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + v) | 0;
            }
            r[0] = r[0] + i | 0, r[1] = r[1] + n | 0, r[2] = r[2] + o | 0, r[3] = r[3] + s | 0, r[4] = r[4] + h | 0, r[5] = r[5] + f | 0, r[6] = r[6] + c | 0, r[7] = r[7] + p | 0;
          },
          _doFinalize: function _doFinalize() {
            var e = this._data,
              r = e.words,
              i = 8 * this._nDataBytes,
              n = 8 * e.sigBytes;
            return r[n >>> 5] |= 128 << 24 - n % 32, r[14 + (n + 64 >>> 9 << 4)] = t.floor(i / 4294967296), r[15 + (n + 64 >>> 9 << 4)] = i, e.sigBytes = 4 * r.length, this._process(), this._hash;
          },
          clone: function clone() {
            var t = o.clone.call(this);
            return t._hash = this._hash.clone(), t;
          }
        });
      e.SHA256 = o._createHelper(f), e.HmacSHA256 = o._createHmacHelper(f);
    }(Math), r.SHA256);
  }),
  s = e(function (t, e) {
    var r, i;
    t.exports = (i = (r = n).lib.WordArray, r.enc.Base64 = {
      stringify: function stringify(t) {
        var e = t.words,
          r = t.sigBytes,
          i = this._map;
        t.clamp();
        for (var n = [], o = 0; o < r; o += 3) {
          for (var s = (e[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (e[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | e[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, h = 0; h < 4 && o + .75 * h < r; h++) {
            n.push(i.charAt(s >>> 6 * (3 - h) & 63));
          }
        }
        var u = i.charAt(64);
        if (u) for (; n.length % 4;) {
          n.push(u);
        }
        return n.join("");
      },
      parse: function parse(t) {
        var e = t.length,
          r = this._map,
          n = this._reverseMap;
        if (!n) {
          n = this._reverseMap = [];
          for (var o = 0; o < r.length; o++) {
            n[r.charCodeAt(o)] = o;
          }
        }
        var s = r.charAt(64);
        if (s) {
          var h = t.indexOf(s);
          -1 !== h && (e = h);
        }
        return function (t, e, r) {
          for (var n = [], o = 0, s = 0; s < e; s++) {
            if (s % 4) {
              var h = r[t.charCodeAt(s - 1)] << s % 4 * 2,
                u = r[t.charCodeAt(s)] >>> 6 - s % 4 * 2;
              n[o >>> 2] |= (h | u) << 24 - o % 4 * 8, o++;
            }
          }
          return i.create(n, o);
        }(t, e, n);
      },
      _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, r.enc.Base64);
  }),
  h = e(function (t, e) {
    t.exports = n.enc.Hex;
  }),
  u = e(function (e, r) {
    (function () {
      var t;
      function r(t, e, r) {
        null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : this.fromString(t, null == e && "string" != typeof t ? 256 : e));
      }
      function i() {
        return new r(null);
      }
      var n = "undefined" != typeof navigator;
      n && "Microsoft Internet Explorer" == navigator.appName ? (r.prototype.am = function (t, e, r, i, n, o) {
        for (var s = 32767 & e, h = e >> 15; --o >= 0;) {
          var u = 32767 & this[t],
            a = this[t++] >> 15,
            f = h * u + a * s;
          n = ((u = s * u + ((32767 & f) << 15) + r[i] + (1073741823 & n)) >>> 30) + (f >>> 15) + h * a + (n >>> 30), r[i++] = 1073741823 & u;
        }
        return n;
      }, t = 30) : n && "Netscape" != navigator.appName ? (r.prototype.am = function (t, e, r, i, n, o) {
        for (; --o >= 0;) {
          var s = e * this[t++] + r[i] + n;
          n = Math.floor(s / 67108864), r[i++] = 67108863 & s;
        }
        return n;
      }, t = 26) : (r.prototype.am = function (t, e, r, i, n, o) {
        for (var s = 16383 & e, h = e >> 14; --o >= 0;) {
          var u = 16383 & this[t],
            a = this[t++] >> 14,
            f = h * u + a * s;
          n = ((u = s * u + ((16383 & f) << 14) + r[i] + n) >> 28) + (f >> 14) + h * a, r[i++] = 268435455 & u;
        }
        return n;
      }, t = 28), r.prototype.DB = t, r.prototype.DM = (1 << t) - 1, r.prototype.DV = 1 << t, r.prototype.FV = Math.pow(2, 52), r.prototype.F1 = 52 - t, r.prototype.F2 = 2 * t - 52;
      var o,
        s,
        h = new Array();
      for (o = "0".charCodeAt(0), s = 0; s <= 9; ++s) {
        h[o++] = s;
      }
      for (o = "a".charCodeAt(0), s = 10; s < 36; ++s) {
        h[o++] = s;
      }
      for (o = "A".charCodeAt(0), s = 10; s < 36; ++s) {
        h[o++] = s;
      }
      function u(t) {
        return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
      }
      function a(t, e) {
        var r = h[t.charCodeAt(e)];
        return null == r ? -1 : r;
      }
      function f(t) {
        var e = i();
        return e.fromInt(t), e;
      }
      function c(t) {
        var e,
          r = 1;
        return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
      }
      function p(t) {
        this.m = t;
      }
      function l(t) {
        this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
      }
      function d(t, e) {
        return t & e;
      }
      function m(t, e) {
        return t | e;
      }
      function v(t, e) {
        return t ^ e;
      }
      function y(t, e) {
        return t & ~e;
      }
      function g(t) {
        if (0 == t) return -1;
        var e = 0;
        return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
      }
      function w(t) {
        for (var e = 0; 0 != t;) {
          t &= t - 1, ++e;
        }
        return e;
      }
      function T() {}
      function b(t) {
        return t;
      }
      function _(t) {
        this.r2 = i(), this.q3 = i(), r.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
      }
      p.prototype.convert = function (t) {
        return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
      }, p.prototype.revert = function (t) {
        return t;
      }, p.prototype.reduce = function (t) {
        t.divRemTo(this.m, null, t);
      }, p.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, p.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      }, l.prototype.convert = function (t) {
        var e = i();
        return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(r.ZERO) > 0 && this.m.subTo(e, e), e;
      }, l.prototype.revert = function (t) {
        var e = i();
        return t.copyTo(e), this.reduce(e), e;
      }, l.prototype.reduce = function (t) {
        for (; t.t <= this.mt2;) {
          t[t.t++] = 0;
        }
        for (var e = 0; e < this.m.t; ++e) {
          var r = 32767 & t[e],
            i = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
          for (t[r = e + this.m.t] += this.m.am(0, i, t, e, 0, this.m.t); t[r] >= t.DV;) {
            t[r] -= t.DV, t[++r]++;
          }
        }
        t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
      }, l.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, l.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      }, r.prototype.copyTo = function (t) {
        for (var e = this.t - 1; e >= 0; --e) {
          t[e] = this[e];
        }
        t.t = this.t, t.s = this.s;
      }, r.prototype.fromInt = function (t) {
        this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
      }, r.prototype.fromString = function (t, e) {
        var i;
        if (16 == e) i = 4;else if (8 == e) i = 3;else if (256 == e) i = 8;else if (2 == e) i = 1;else if (32 == e) i = 5;else {
          if (4 != e) return void this.fromRadix(t, e);
          i = 2;
        }
        this.t = 0, this.s = 0;
        for (var n = t.length, o = !1, s = 0; --n >= 0;) {
          var h = 8 == i ? 255 & t[n] : a(t, n);
          h < 0 ? "-" == t.charAt(n) && (o = !0) : (o = !1, 0 == s ? this[this.t++] = h : s + i > this.DB ? (this[this.t - 1] |= (h & (1 << this.DB - s) - 1) << s, this[this.t++] = h >> this.DB - s) : this[this.t - 1] |= h << s, (s += i) >= this.DB && (s -= this.DB));
        }
        8 == i && 0 != (128 & t[0]) && (this.s = -1, s > 0 && (this[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), o && r.ZERO.subTo(this, this);
      }, r.prototype.clamp = function () {
        for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;) {
          --this.t;
        }
      }, r.prototype.dlShiftTo = function (t, e) {
        var r;
        for (r = this.t - 1; r >= 0; --r) {
          e[r + t] = this[r];
        }
        for (r = t - 1; r >= 0; --r) {
          e[r] = 0;
        }
        e.t = this.t + t, e.s = this.s;
      }, r.prototype.drShiftTo = function (t, e) {
        for (var r = t; r < this.t; ++r) {
          e[r - t] = this[r];
        }
        e.t = Math.max(this.t - t, 0), e.s = this.s;
      }, r.prototype.lShiftTo = function (t, e) {
        var r,
          i = t % this.DB,
          n = this.DB - i,
          o = (1 << n) - 1,
          s = Math.floor(t / this.DB),
          h = this.s << i & this.DM;
        for (r = this.t - 1; r >= 0; --r) {
          e[r + s + 1] = this[r] >> n | h, h = (this[r] & o) << i;
        }
        for (r = s - 1; r >= 0; --r) {
          e[r] = 0;
        }
        e[s] = h, e.t = this.t + s + 1, e.s = this.s, e.clamp();
      }, r.prototype.rShiftTo = function (t, e) {
        e.s = this.s;
        var r = Math.floor(t / this.DB);
        if (r >= this.t) e.t = 0;else {
          var i = t % this.DB,
            n = this.DB - i,
            o = (1 << i) - 1;
          e[0] = this[r] >> i;
          for (var s = r + 1; s < this.t; ++s) {
            e[s - r - 1] |= (this[s] & o) << n, e[s - r] = this[s] >> i;
          }
          i > 0 && (e[this.t - r - 1] |= (this.s & o) << n), e.t = this.t - r, e.clamp();
        }
      }, r.prototype.subTo = function (t, e) {
        for (var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;) {
          i += this[r] - t[r], e[r++] = i & this.DM, i >>= this.DB;
        }
        if (t.t < this.t) {
          for (i -= t.s; r < this.t;) {
            i += this[r], e[r++] = i & this.DM, i >>= this.DB;
          }
          i += this.s;
        } else {
          for (i += this.s; r < t.t;) {
            i -= t[r], e[r++] = i & this.DM, i >>= this.DB;
          }
          i -= t.s;
        }
        e.s = i < 0 ? -1 : 0, i < -1 ? e[r++] = this.DV + i : i > 0 && (e[r++] = i), e.t = r, e.clamp();
      }, r.prototype.multiplyTo = function (t, e) {
        var i = this.abs(),
          n = t.abs(),
          o = i.t;
        for (e.t = o + n.t; --o >= 0;) {
          e[o] = 0;
        }
        for (o = 0; o < n.t; ++o) {
          e[o + i.t] = i.am(0, n[o], e, o, 0, i.t);
        }
        e.s = 0, e.clamp(), this.s != t.s && r.ZERO.subTo(e, e);
      }, r.prototype.squareTo = function (t) {
        for (var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;) {
          t[r] = 0;
        }
        for (r = 0; r < e.t - 1; ++r) {
          var i = e.am(r, e[r], t, 2 * r, 0, 1);
          (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, i, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
        }
        t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
      }, r.prototype.divRemTo = function (t, e, n) {
        var o = t.abs();
        if (!(o.t <= 0)) {
          var s = this.abs();
          if (s.t < o.t) return null != e && e.fromInt(0), void (null != n && this.copyTo(n));
          null == n && (n = i());
          var h = i(),
            u = this.s,
            a = t.s,
            f = this.DB - c(o[o.t - 1]);
          f > 0 ? (o.lShiftTo(f, h), s.lShiftTo(f, n)) : (o.copyTo(h), s.copyTo(n));
          var p = h.t,
            l = h[p - 1];
          if (0 != l) {
            var d = l * (1 << this.F1) + (p > 1 ? h[p - 2] >> this.F2 : 0),
              m = this.FV / d,
              v = (1 << this.F1) / d,
              y = 1 << this.F2,
              g = n.t,
              w = g - p,
              T = null == e ? i() : e;
            for (h.dlShiftTo(w, T), n.compareTo(T) >= 0 && (n[n.t++] = 1, n.subTo(T, n)), r.ONE.dlShiftTo(p, T), T.subTo(h, h); h.t < p;) {
              h[h.t++] = 0;
            }
            for (; --w >= 0;) {
              var b = n[--g] == l ? this.DM : Math.floor(n[g] * m + (n[g - 1] + y) * v);
              if ((n[g] += h.am(0, b, n, w, 0, p)) < b) for (h.dlShiftTo(w, T), n.subTo(T, n); n[g] < --b;) {
                n.subTo(T, n);
              }
            }
            null != e && (n.drShiftTo(p, e), u != a && r.ZERO.subTo(e, e)), n.t = p, n.clamp(), f > 0 && n.rShiftTo(f, n), u < 0 && r.ZERO.subTo(n, n);
          }
        }
      }, r.prototype.invDigit = function () {
        if (this.t < 1) return 0;
        var t = this[0];
        if (0 == (1 & t)) return 0;
        var e = 3 & t;
        return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
      }, r.prototype.isEven = function () {
        return 0 == (this.t > 0 ? 1 & this[0] : this.s);
      }, r.prototype.exp = function (t, e) {
        if (t > 4294967295 || t < 1) return r.ONE;
        var n = i(),
          o = i(),
          s = e.convert(this),
          h = c(t) - 1;
        for (s.copyTo(n); --h >= 0;) {
          if (e.sqrTo(n, o), (t & 1 << h) > 0) e.mulTo(o, s, n);else {
            var u = n;
            n = o, o = u;
          }
        }
        return e.revert(n);
      }, r.prototype.toString = function (t) {
        if (this.s < 0) return "-" + this.negate().toString(t);
        var e;
        if (16 == t) e = 4;else if (8 == t) e = 3;else if (2 == t) e = 1;else if (32 == t) e = 5;else {
          if (4 != t) return this.toRadix(t);
          e = 2;
        }
        var r,
          i = (1 << e) - 1,
          n = !1,
          o = "",
          s = this.t,
          h = this.DB - s * this.DB % e;
        if (s-- > 0) for (h < this.DB && (r = this[s] >> h) > 0 && (n = !0, o = u(r)); s >= 0;) {
          h < e ? (r = (this[s] & (1 << h) - 1) << e - h, r |= this[--s] >> (h += this.DB - e)) : (r = this[s] >> (h -= e) & i, h <= 0 && (h += this.DB, --s)), r > 0 && (n = !0), n && (o += u(r));
        }
        return n ? o : "0";
      }, r.prototype.negate = function () {
        var t = i();
        return r.ZERO.subTo(this, t), t;
      }, r.prototype.abs = function () {
        return this.s < 0 ? this.negate() : this;
      }, r.prototype.compareTo = function (t) {
        var e = this.s - t.s;
        if (0 != e) return e;
        var r = this.t;
        if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;
        for (; --r >= 0;) {
          if (0 != (e = this[r] - t[r])) return e;
        }
        return 0;
      }, r.prototype.bitLength = function () {
        return this.t <= 0 ? 0 : this.DB * (this.t - 1) + c(this[this.t - 1] ^ this.s & this.DM);
      }, r.prototype.mod = function (t) {
        var e = i();
        return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(r.ZERO) > 0 && t.subTo(e, e), e;
      }, r.prototype.modPowInt = function (t, e) {
        var r;
        return r = t < 256 || e.isEven() ? new p(e) : new l(e), this.exp(t, r);
      }, r.ZERO = f(0), r.ONE = f(1), T.prototype.convert = b, T.prototype.revert = b, T.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r);
      }, T.prototype.sqrTo = function (t, e) {
        t.squareTo(e);
      }, _.prototype.convert = function (t) {
        if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
        if (t.compareTo(this.m) < 0) return t;
        var e = i();
        return t.copyTo(e), this.reduce(e), e;
      }, _.prototype.revert = function (t) {
        return t;
      }, _.prototype.reduce = function (t) {
        for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) {
          t.dAddOffset(1, this.m.t + 1);
        }
        for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) {
          t.subTo(this.m, t);
        }
      }, _.prototype.mulTo = function (t, e, r) {
        t.multiplyTo(e, r), this.reduce(r);
      }, _.prototype.sqrTo = function (t, e) {
        t.squareTo(e), this.reduce(e);
      };
      var S,
        A,
        D,
        B = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
        x = (1 << 26) / B[B.length - 1];
      function E() {
        var t;
        t = new Date().getTime(), A[D++] ^= 255 & t, A[D++] ^= t >> 8 & 255, A[D++] ^= t >> 16 & 255, A[D++] ^= t >> 24 & 255, D >= j && (D -= j);
      }
      if (r.prototype.chunkSize = function (t) {
        return Math.floor(Math.LN2 * this.DB / Math.log(t));
      }, r.prototype.toRadix = function (t) {
        if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
        var e = this.chunkSize(t),
          r = Math.pow(t, e),
          n = f(r),
          o = i(),
          s = i(),
          h = "";
        for (this.divRemTo(n, o, s); o.signum() > 0;) {
          h = (r + s.intValue()).toString(t).substr(1) + h, o.divRemTo(n, o, s);
        }
        return s.intValue().toString(t) + h;
      }, r.prototype.fromRadix = function (t, e) {
        this.fromInt(0), null == e && (e = 10);
        for (var i = this.chunkSize(e), n = Math.pow(e, i), o = !1, s = 0, h = 0, u = 0; u < t.length; ++u) {
          var f = a(t, u);
          f < 0 ? "-" == t.charAt(u) && 0 == this.signum() && (o = !0) : (h = e * h + f, ++s >= i && (this.dMultiply(n), this.dAddOffset(h, 0), s = 0, h = 0));
        }
        s > 0 && (this.dMultiply(Math.pow(e, s)), this.dAddOffset(h, 0)), o && r.ZERO.subTo(this, this);
      }, r.prototype.fromNumber = function (t, e, i) {
        if ("number" == typeof e) {
          if (t < 2) this.fromInt(1);else for (this.fromNumber(t, i), this.testBit(t - 1) || this.bitwiseTo(r.ONE.shiftLeft(t - 1), m, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);) {
            this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(r.ONE.shiftLeft(t - 1), this);
          }
        } else {
          var n = new Array(),
            o = 7 & t;
          n.length = 1 + (t >> 3), e.nextBytes(n), o > 0 ? n[0] &= (1 << o) - 1 : n[0] = 0, this.fromString(n, 256);
        }
      }, r.prototype.bitwiseTo = function (t, e, r) {
        var i,
          n,
          o = Math.min(t.t, this.t);
        for (i = 0; i < o; ++i) {
          r[i] = e(this[i], t[i]);
        }
        if (t.t < this.t) {
          for (n = t.s & this.DM, i = o; i < this.t; ++i) {
            r[i] = e(this[i], n);
          }
          r.t = this.t;
        } else {
          for (n = this.s & this.DM, i = o; i < t.t; ++i) {
            r[i] = e(n, t[i]);
          }
          r.t = t.t;
        }
        r.s = e(this.s, t.s), r.clamp();
      }, r.prototype.changeBit = function (t, e) {
        var i = r.ONE.shiftLeft(t);
        return this.bitwiseTo(i, e, i), i;
      }, r.prototype.addTo = function (t, e) {
        for (var r = 0, i = 0, n = Math.min(t.t, this.t); r < n;) {
          i += this[r] + t[r], e[r++] = i & this.DM, i >>= this.DB;
        }
        if (t.t < this.t) {
          for (i += t.s; r < this.t;) {
            i += this[r], e[r++] = i & this.DM, i >>= this.DB;
          }
          i += this.s;
        } else {
          for (i += this.s; r < t.t;) {
            i += t[r], e[r++] = i & this.DM, i >>= this.DB;
          }
          i += t.s;
        }
        e.s = i < 0 ? -1 : 0, i > 0 ? e[r++] = i : i < -1 && (e[r++] = this.DV + i), e.t = r, e.clamp();
      }, r.prototype.dMultiply = function (t) {
        this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
      }, r.prototype.dAddOffset = function (t, e) {
        if (0 != t) {
          for (; this.t <= e;) {
            this[this.t++] = 0;
          }
          for (this[e] += t; this[e] >= this.DV;) {
            this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
          }
        }
      }, r.prototype.multiplyLowerTo = function (t, e, r) {
        var i,
          n = Math.min(this.t + t.t, e);
        for (r.s = 0, r.t = n; n > 0;) {
          r[--n] = 0;
        }
        for (i = r.t - this.t; n < i; ++n) {
          r[n + this.t] = this.am(0, t[n], r, n, 0, this.t);
        }
        for (i = Math.min(t.t, e); n < i; ++n) {
          this.am(0, t[n], r, n, 0, e - n);
        }
        r.clamp();
      }, r.prototype.multiplyUpperTo = function (t, e, r) {
        --e;
        var i = r.t = this.t + t.t - e;
        for (r.s = 0; --i >= 0;) {
          r[i] = 0;
        }
        for (i = Math.max(e - this.t, 0); i < t.t; ++i) {
          r[this.t + i - e] = this.am(e - i, t[i], r, 0, 0, this.t + i - e);
        }
        r.clamp(), r.drShiftTo(1, r);
      }, r.prototype.modInt = function (t) {
        if (t <= 0) return 0;
        var e = this.DV % t,
          r = this.s < 0 ? t - 1 : 0;
        if (this.t > 0) if (0 == e) r = this[0] % t;else for (var i = this.t - 1; i >= 0; --i) {
          r = (e * r + this[i]) % t;
        }
        return r;
      }, r.prototype.millerRabin = function (t) {
        var e = this.subtract(r.ONE),
          n = e.getLowestSetBit();
        if (n <= 0) return !1;
        var o = e.shiftRight(n);
        (t = t + 1 >> 1) > B.length && (t = B.length);
        for (var s = i(), h = 0; h < t; ++h) {
          s.fromInt(B[Math.floor(Math.random() * B.length)]);
          var u = s.modPow(o, this);
          if (0 != u.compareTo(r.ONE) && 0 != u.compareTo(e)) {
            for (var a = 1; a++ < n && 0 != u.compareTo(e);) {
              if (0 == (u = u.modPowInt(2, this)).compareTo(r.ONE)) return !1;
            }
            if (0 != u.compareTo(e)) return !1;
          }
        }
        return !0;
      }, r.prototype.clone = function () {
        var t = i();
        return this.copyTo(t), t;
      }, r.prototype.intValue = function () {
        if (this.s < 0) {
          if (1 == this.t) return this[0] - this.DV;
          if (0 == this.t) return -1;
        } else {
          if (1 == this.t) return this[0];
          if (0 == this.t) return 0;
        }
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
      }, r.prototype.byteValue = function () {
        return 0 == this.t ? this.s : this[0] << 24 >> 24;
      }, r.prototype.shortValue = function () {
        return 0 == this.t ? this.s : this[0] << 16 >> 16;
      }, r.prototype.signum = function () {
        return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
      }, r.prototype.toByteArray = function () {
        var t = this.t,
          e = new Array();
        e[0] = this.s;
        var r,
          i = this.DB - t * this.DB % 8,
          n = 0;
        if (t-- > 0) for (i < this.DB && (r = this[t] >> i) != (this.s & this.DM) >> i && (e[n++] = r | this.s << this.DB - i); t >= 0;) {
          i < 8 ? (r = (this[t] & (1 << i) - 1) << 8 - i, r |= this[--t] >> (i += this.DB - 8)) : (r = this[t] >> (i -= 8) & 255, i <= 0 && (i += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == n && (128 & this.s) != (128 & r) && ++n, (n > 0 || r != this.s) && (e[n++] = r);
        }
        return e;
      }, r.prototype.equals = function (t) {
        return 0 == this.compareTo(t);
      }, r.prototype.min = function (t) {
        return this.compareTo(t) < 0 ? this : t;
      }, r.prototype.max = function (t) {
        return this.compareTo(t) > 0 ? this : t;
      }, r.prototype.and = function (t) {
        var e = i();
        return this.bitwiseTo(t, d, e), e;
      }, r.prototype.or = function (t) {
        var e = i();
        return this.bitwiseTo(t, m, e), e;
      }, r.prototype.xor = function (t) {
        var e = i();
        return this.bitwiseTo(t, v, e), e;
      }, r.prototype.andNot = function (t) {
        var e = i();
        return this.bitwiseTo(t, y, e), e;
      }, r.prototype.not = function () {
        for (var t = i(), e = 0; e < this.t; ++e) {
          t[e] = this.DM & ~this[e];
        }
        return t.t = this.t, t.s = ~this.s, t;
      }, r.prototype.shiftLeft = function (t) {
        var e = i();
        return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
      }, r.prototype.shiftRight = function (t) {
        var e = i();
        return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
      }, r.prototype.getLowestSetBit = function () {
        for (var t = 0; t < this.t; ++t) {
          if (0 != this[t]) return t * this.DB + g(this[t]);
        }
        return this.s < 0 ? this.t * this.DB : -1;
      }, r.prototype.bitCount = function () {
        for (var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r) {
          t += w(this[r] ^ e);
        }
        return t;
      }, r.prototype.testBit = function (t) {
        var e = Math.floor(t / this.DB);
        return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
      }, r.prototype.setBit = function (t) {
        return this.changeBit(t, m);
      }, r.prototype.clearBit = function (t) {
        return this.changeBit(t, y);
      }, r.prototype.flipBit = function (t) {
        return this.changeBit(t, v);
      }, r.prototype.add = function (t) {
        var e = i();
        return this.addTo(t, e), e;
      }, r.prototype.subtract = function (t) {
        var e = i();
        return this.subTo(t, e), e;
      }, r.prototype.multiply = function (t) {
        var e = i();
        return this.multiplyTo(t, e), e;
      }, r.prototype.divide = function (t) {
        var e = i();
        return this.divRemTo(t, e, null), e;
      }, r.prototype.remainder = function (t) {
        var e = i();
        return this.divRemTo(t, null, e), e;
      }, r.prototype.divideAndRemainder = function (t) {
        var e = i(),
          r = i();
        return this.divRemTo(t, e, r), new Array(e, r);
      }, r.prototype.modPow = function (t, e) {
        var r,
          n,
          o = t.bitLength(),
          s = f(1);
        if (o <= 0) return s;
        r = o < 18 ? 1 : o < 48 ? 3 : o < 144 ? 4 : o < 768 ? 5 : 6, n = o < 8 ? new p(e) : e.isEven() ? new _(e) : new l(e);
        var h = new Array(),
          u = 3,
          a = r - 1,
          d = (1 << r) - 1;
        if (h[1] = n.convert(this), r > 1) {
          var m = i();
          for (n.sqrTo(h[1], m); u <= d;) {
            h[u] = i(), n.mulTo(m, h[u - 2], h[u]), u += 2;
          }
        }
        var v,
          y,
          g = t.t - 1,
          w = !0,
          T = i();
        for (o = c(t[g]) - 1; g >= 0;) {
          for (o >= a ? v = t[g] >> o - a & d : (v = (t[g] & (1 << o + 1) - 1) << a - o, g > 0 && (v |= t[g - 1] >> this.DB + o - a)), u = r; 0 == (1 & v);) {
            v >>= 1, --u;
          }
          if ((o -= u) < 0 && (o += this.DB, --g), w) h[v].copyTo(s), w = !1;else {
            for (; u > 1;) {
              n.sqrTo(s, T), n.sqrTo(T, s), u -= 2;
            }
            u > 0 ? n.sqrTo(s, T) : (y = s, s = T, T = y), n.mulTo(T, h[v], s);
          }
          for (; g >= 0 && 0 == (t[g] & 1 << o);) {
            n.sqrTo(s, T), y = s, s = T, T = y, --o < 0 && (o = this.DB - 1, --g);
          }
        }
        return n.revert(s);
      }, r.prototype.modInverse = function (t) {
        var e = t.isEven();
        if (this.isEven() && e || 0 == t.signum()) return r.ZERO;
        for (var i = t.clone(), n = this.clone(), o = f(1), s = f(0), h = f(0), u = f(1); 0 != i.signum();) {
          for (; i.isEven();) {
            i.rShiftTo(1, i), e ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(t, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(t, s), s.rShiftTo(1, s);
          }
          for (; n.isEven();) {
            n.rShiftTo(1, n), e ? (h.isEven() && u.isEven() || (h.addTo(this, h), u.subTo(t, u)), h.rShiftTo(1, h)) : u.isEven() || u.subTo(t, u), u.rShiftTo(1, u);
          }
          i.compareTo(n) >= 0 ? (i.subTo(n, i), e && o.subTo(h, o), s.subTo(u, s)) : (n.subTo(i, n), e && h.subTo(o, h), u.subTo(s, u));
        }
        return 0 != n.compareTo(r.ONE) ? r.ZERO : u.compareTo(t) >= 0 ? u.subtract(t) : u.signum() < 0 ? (u.addTo(t, u), u.signum() < 0 ? u.add(t) : u) : u;
      }, r.prototype.pow = function (t) {
        return this.exp(t, new T());
      }, r.prototype.gcd = function (t) {
        var e = this.s < 0 ? this.negate() : this.clone(),
          r = t.s < 0 ? t.negate() : t.clone();
        if (e.compareTo(r) < 0) {
          var i = e;
          e = r, r = i;
        }
        var n = e.getLowestSetBit(),
          o = r.getLowestSetBit();
        if (o < 0) return e;
        for (n < o && (o = n), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;) {
          (n = e.getLowestSetBit()) > 0 && e.rShiftTo(n, e), (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
        }
        return o > 0 && r.lShiftTo(o, r), r;
      }, r.prototype.isProbablePrime = function (t) {
        var e,
          r = this.abs();
        if (1 == r.t && r[0] <= B[B.length - 1]) {
          for (e = 0; e < B.length; ++e) {
            if (r[0] == B[e]) return !0;
          }
          return !1;
        }
        if (r.isEven()) return !1;
        for (e = 1; e < B.length;) {
          for (var i = B[e], n = e + 1; n < B.length && i < x;) {
            i *= B[n++];
          }
          for (i = r.modInt(i); e < n;) {
            if (i % B[e++] == 0) return !1;
          }
        }
        return r.millerRabin(t);
      }, r.prototype.square = function () {
        var t = i();
        return this.squareTo(t), t;
      }, r.prototype.Barrett = _, null == A) {
        var k;
        if (A = new Array(), D = 0, "undefined" != typeof window && window.crypto) if (window.crypto.getRandomValues) {
          var I = new Uint8Array(32);
          for (window.crypto.getRandomValues(I), k = 0; k < 32; ++k) {
            A[D++] = I[k];
          }
        } else if ("Netscape" == navigator.appName && navigator.appVersion < "5") {
          var M = window.crypto.random(32);
          for (k = 0; k < M.length; ++k) {
            A[D++] = 255 & M.charCodeAt(k);
          }
        }
        for (; D < j;) {
          k = Math.floor(65536 * Math.random()), A[D++] = k >>> 8, A[D++] = 255 & k;
        }
        D = 0, E();
      }
      function R() {
        if (null == S) {
          for (E(), (S = new O()).init(A), D = 0; D < A.length; ++D) {
            A[D] = 0;
          }
          D = 0;
        }
        return S.next();
      }
      function C() {}
      function O() {
        this.i = 0, this.j = 0, this.S = new Array();
      }
      C.prototype.nextBytes = function (t) {
        var e;
        for (e = 0; e < t.length; ++e) {
          t[e] = R();
        }
      }, O.prototype.init = function (t) {
        var e, r, i;
        for (e = 0; e < 256; ++e) {
          this.S[e] = e;
        }
        for (r = 0, e = 0; e < 256; ++e) {
          i = this.S[e], this.S[e] = this.S[r = r + this.S[e] + t[e % t.length] & 255], this.S[r] = i;
        }
        this.i = 0, this.j = 0;
      }, O.prototype.next = function () {
        var t;
        return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255];
      };
      var j = 256;
      e.exports = {
        default: r,
        BigInteger: r,
        SecureRandom: C
      };
    }).call(t);
  }),
  a = {
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    ripemd160: "3021300906052b2403020105000414"
  },
  f = {
    sha256: o
  };
function c(t, e) {
  if (this.n = null, this.e = 0, !(null != t && null != e && t.length > 0 && e.length > 0)) throw new Error("Invalid key data");
  this.n = new u.BigInteger(t, 16), this.e = parseInt(e, 16);
}
c.prototype.verify = function (t, e) {
  e = e.replace(/[^0-9a-f]|[\s\n]]/gi, "");
  var r = new u.BigInteger(e, 16);
  if (r.bitLength() > this.n.bitLength()) throw new Error("Signature does not match with the key modulus.");
  var i = function (t) {
    for (var e in a) {
      var r = a[e],
        i = r.length;
      if (t.substring(0, i) === r) return {
        alg: e,
        hash: t.substring(i)
      };
    }
    return [];
  }(r.modPowInt(this.e, this.n).toString(16).replace(/^1f+00/, ""));
  if (0 === i.length) return !1;
  if (!f.hasOwnProperty(i.alg)) throw new Error("Hashing algorithm is not supported.");
  var n = f[i.alg](t).toString();
  return i.hash === n;
};
for (var p = [], l = [], d = "undefined" != typeof Uint8Array ? Uint8Array : Array, m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", v = 0, y = m.length; v < y; ++v) {
  p[v] = m[v], l[m.charCodeAt(v)] = v;
}
l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
var g = function g(t) {
  var e,
    r,
    i = function (t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }(t),
    n = i[0],
    o = i[1],
    s = new d(function (t, e, r) {
      return 3 * (e + r) / 4 - r;
    }(0, n, o)),
    h = 0,
    u = o > 0 ? n - 4 : n;
  for (r = 0; r < u; r += 4) {
    e = l[t.charCodeAt(r)] << 18 | l[t.charCodeAt(r + 1)] << 12 | l[t.charCodeAt(r + 2)] << 6 | l[t.charCodeAt(r + 3)], s[h++] = e >> 16 & 255, s[h++] = e >> 8 & 255, s[h++] = 255 & e;
  }
  return 2 === o && (e = l[t.charCodeAt(r)] << 2 | l[t.charCodeAt(r + 1)] >> 4, s[h++] = 255 & e), 1 === o && (e = l[t.charCodeAt(r)] << 10 | l[t.charCodeAt(r + 1)] << 4 | l[t.charCodeAt(r + 2)] >> 2, s[h++] = e >> 8 & 255, s[h++] = 255 & e), s;
};
function w(t) {
  var e = t.length % 4;
  return 0 === e ? t : t + new Array(4 - e + 1).join("=");
}
function T(t) {
  return t = w(t).replace(/\-/g, "+").replace(/_/g, "/"), decodeURIComponent(function (t) {
    for (var e = "", r = 0; r < t.length; r++) {
      e += String.fromCharCode(t[r]);
    }
    return e;
  }(g(t)).split("").map(function (t) {
    return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
}
function b(t) {
  return function (t) {
    for (var e = "", r = 0; r < t.length; r++) {
      var i = t[r].toString(16);
      e += 2 === i.length ? i : "0" + i;
    }
    return e;
  }(g(w(t)));
}
var _ = e(function (e) {
  var r, i;
  r = t, i = function i() {
    function t(t) {
      var e = [];
      if (0 === t.length) return "";
      if ("string" != typeof t[0]) throw new TypeError("Url must be a string. Received " + t[0]);
      if (t[0].match(/^[^/:]+:\/*$/) && t.length > 1) {
        var r = t.shift();
        t[0] = r + t[0];
      }
      t[0] = t[0].match(/^file:\/\/\//) ? t[0].replace(/^([^/:]+):\/*/, "$1:///") : t[0].replace(/^([^/:]+):\/*/, "$1://");
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        if ("string" != typeof n) throw new TypeError("Url must be a string. Received " + n);
        "" !== n && (i > 0 && (n = n.replace(/^[\/]+/, "")), n = n.replace(/[\/]+$/, i < t.length - 1 ? "" : "/"), e.push(n));
      }
      var o = e.join("/"),
        s = (o = o.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
      return s.shift() + (s.length > 0 ? "?" : "") + s.join("&");
    }
    return function () {
      return t("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
    };
  }, e.exports ? e.exports = i() : r.urljoin = i();
});
function S(t, e) {
  return e = e || {}, new Promise(function (r, i) {
    var n = new XMLHttpRequest(),
      o = [],
      s = [],
      h = {},
      u = function u() {
        return {
          ok: 2 == (n.status / 100 | 0),
          statusText: n.statusText,
          status: n.status,
          url: n.responseURL,
          text: function text() {
            return Promise.resolve(n.responseText);
          },
          json: function json() {
            return Promise.resolve(n.responseText).then(JSON.parse);
          },
          blob: function blob() {
            return Promise.resolve(new Blob([n.response]));
          },
          clone: u,
          headers: {
            keys: function keys() {
              return o;
            },
            entries: function entries() {
              return s;
            },
            get: function get(t) {
              return h[t.toLowerCase()];
            },
            has: function has(t) {
              return t.toLowerCase() in h;
            }
          }
        };
      };
    for (var a in n.open(e.method || "get", t, !0), n.onload = function () {
      n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (t, e, r) {
        o.push(e = e.toLowerCase()), s.push([e, r]), h[e] = h[e] ? h[e] + "," + r : r;
      }), r(u());
    }, n.onerror = i, n.withCredentials = "include" == e.credentials, e.headers) {
      n.setRequestHeader(a, e.headers[a]);
    }
    n.send(e.body || null);
  });
}
function A(t) {
  if (t.ok) return t.json();
  var e = new Error(t.statusText);
  return e.response = t, Promise.reject(e);
}
function D(t) {
  this.name = "ConfigurationError", this.message = t || "";
}
function B(t) {
  this.name = "TokenValidationError", this.message = t || "";
}
D.prototype = Error.prototype, B.prototype = Error.prototype;
var x = function () {
  function t() {}
  var e = t.prototype;
  return e.get = function () {
    return null;
  }, e.has = function () {
    return null;
  }, e.set = function () {
    return null;
  }, t;
}();
r.polyfill();
var E = function E(t) {
    return "number" == typeof t;
  },
  k = function k() {
    return new Date();
  };
function I(t) {
  var e = t || {};
  if (this.jwksCache = e.jwksCache || new x(), this.expectedAlg = e.expectedAlg || "RS256", this.issuer = e.issuer, this.audience = e.audience, this.leeway = 0 === e.leeway ? 0 : e.leeway || 60, this.jwksURI = e.jwksURI, this.maxAge = e.maxAge, this.__clock = "function" == typeof e.__clock ? e.__clock : k, this.leeway < 0 || this.leeway > 300) throw new D("The leeway should be positive and lower than five minutes.");
  if ("RS256" !== this.expectedAlg) throw new D('Signature algorithm of "' + this.expectedAlg + '" is not supported. Expected the ID token to be signed with "RS256".');
}
I.prototype.verify = function (t, e, r) {
  if (!r && e && "function" == typeof e && (r = e, e = void 0), !t) return r(new B("ID token is required but missing"), null);
  var i = this.decode(t);
  if (i instanceof Error) return r(new B("ID token could not be decoded"), null);
  var n = i.encoded.header + "." + i.encoded.payload,
    o = b(i.encoded.signature),
    s = i.header.alg,
    h = i.header.kid,
    u = i.payload.aud,
    a = i.payload.sub,
    f = i.payload.iss,
    c = i.payload.exp,
    p = i.payload.nbf,
    l = i.payload.iat,
    d = i.payload.azp,
    m = i.payload.auth_time,
    v = i.payload.nonce,
    y = this.__clock(),
    g = this;
  if (g.expectedAlg !== s) return r(new B('Signature algorithm of "' + s + '" is not supported. Expected the ID token to be signed with "RS256".'), null);
  this.getRsaVerifier(f, h, function (t, s) {
    if (t) return r(t, null);
    if (!s.verify(n, o)) return r(new B("Invalid ID token signature."), null);
    if (!f || "string" != typeof f) return r(new B("Issuer (iss) claim must be a string present in the ID token"), null);
    if (g.issuer !== f) return r(new B('Issuer (iss) claim mismatch in the ID token, expected "' + g.issuer + '", found "' + f + '"'), null);
    if (!a || "string" != typeof a) return r(new B("Subject (sub) claim must be a string present in the ID token"), null);
    if (!u || "string" != typeof u && !Array.isArray(u)) return r(new B("Audience (aud) claim must be a string or array of strings present in the ID token"), null);
    if (Array.isArray(u) && !u.includes(g.audience)) return r(new B('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but was not one of "' + u.join(", ") + '"'), null);
    if ("string" == typeof u && g.audience !== u) return r(new B('Audience (aud) claim mismatch in the ID token; expected "' + g.audience + '" but found "' + u + '"'), null);
    if (e) {
      if (!v || "string" != typeof v) return r(new B("Nonce (nonce) claim must be a string present in the ID token"), null);
      if (v !== e) return r(new B('Nonce (nonce) claim value mismatch in the ID token; expected "' + e + '", found "' + v + '"'), null);
    }
    if (Array.isArray(u) && u.length > 1) {
      if (!d || "string" != typeof d) return r(new B("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values"), null);
      if (d !== g.audience) return r(new B('Authorized Party (azp) claim mismatch in the ID token; expected "' + g.audience + '", found "' + d + '"'), null);
    }
    if (!c || !E(c)) return r(new B("Expiration Time (exp) claim must be a number present in the ID token"), null);
    if (!l || !E(l)) return r(new B("Issued At (iat) claim must be a number present in the ID token"), null);
    var h = c + g.leeway,
      w = new Date(0);
    if (w.setUTCSeconds(h), y > w) return r(new B('Expiration Time (exp) claim error in the ID token; current time "' + y + '" is after expiration time "' + w + '"'), null);
    if (p && E(p)) {
      var T = p - g.leeway,
        b = new Date(0);
      if (b.setUTCSeconds(T), y < b) return r(new B('Not Before Time (nbf) claim error in the ID token; current time "' + y + '" is before the not before time "' + b + '"'), null);
    }
    if (g.maxAge) {
      if (!m || !E(m)) return r(new B("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified"), null);
      var _ = m + g.maxAge + g.leeway,
        S = new Date(0);
      if (S.setUTCSeconds(_), y > S) return r(new B('Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time "' + y + '" is after last auth time at "' + S + '"'), null);
    }
    return r(null, i.payload);
  });
}, I.prototype.getRsaVerifier = function (t, e, r) {
  var i = this,
    n = t + e;
  Promise.resolve(this.jwksCache.has(n)).then(function (r) {
    return r ? i.jwksCache.get(n) : (o = {
      jwksURI: i.jwksURI,
      iss: t,
      kid: e
    }, ("undefined" == typeof fetch ? S : fetch)(o.jwksURI || _(o.iss, ".well-known", "jwks.json")).then(A).then(function (t) {
      var e,
        r,
        i,
        n = null;
      for (e = 0; e < t.keys.length && null === n; e++) {
        (r = t.keys[e]).kid === o.kid && (n = r);
      }
      if (!n) throw new Error('Could not find a public key for Key ID (kid) "' + o.kid + '"');
      return {
        modulus: b((i = n).n),
        exp: b(i.e)
      };
    }).catch(function (t) {
      throw t;
    }));
    var o;
  }).then(function (t) {
    if (!t || !t.modulus || !t.exp) throw new Error("Empty keyInfo in response");
    return Promise.resolve(i.jwksCache.set(n, t)).then(function () {
      r && r(null, new c(t.modulus, t.exp));
    });
  }).catch(function (t) {
    r && r(t);
  });
}, I.prototype.decode = function (t) {
  var e,
    r,
    i = t.split(".");
  if (3 !== i.length) return new B("Cannot decode a malformed JWT");
  try {
    e = JSON.parse(T(i[0])), r = JSON.parse(T(i[1]));
  } catch (t) {
    return new B("Token header or payload is not valid JSON");
  }
  return {
    header: e,
    payload: r,
    encoded: {
      header: i[0],
      payload: i[1],
      signature: i[2]
    }
  };
}, I.prototype.validateAccessToken = function (t, e, r, i) {
  if (this.expectedAlg !== e) return i(new B('Signature algorithm of "' + e + '" is not supported. Expected "' + this.expectedAlg + '"'));
  var n,
    u = o(t),
    a = h.stringify(u),
    f = a.substring(0, a.length / 2),
    c = h.parse(f),
    p = s.stringify(c);
  return i((n = {
    "+": "-",
    "/": "_",
    "=": ""
  }, p.replace(/[+/=]/g, function (t) {
    return n[t];
  }) !== r ? new B("Invalid access_token") : null));
};
export { I as default };